import React from "react";
import walletIcon from "../assets/icons/wallet.png";

const BudgetCard = ({ title, value, label, color }) => {
  return (
    <div className={`border border-[#DDDDDD] rounded-md p-4 ${color} text-white w-full flex flex-col gap-4`}>
      <div className="flex justify-between items-center">
        <img loading="lazy" className="w-11 h-11" src={walletIcon} alt="wallet icon" />
        <h1 className="text-sm">{title}</h1>
      </div>
      <div>
        <h1 className="font-semibold">{value}</h1>
      <h2 className="text-sm">{label}</h2>
      </div>
    </div>
  );
};

export default BudgetCard;
